import Button from 'assets/components/button/Button';
import ThemeButtonMenuItem from 'assets/components/button/themes/Theme.Button.MenuItem';
import DataMap from 'assets/components/dataMap/DataMap';
import Icon from 'assets/components/icon/Icon';
import useUIEditor from 'assets/hooks/uiEditor/UIEditor';
import { getLocales } from 'assets/locales/Locale';
import DropdownButton from 'assets/templates/dropdownButton/DropdownButton';
import ThemeDropdownButtonPopup from 'assets/templates/dropdownButton/themes/Theme.DropdownButton.Popup';
import { UICommand } from 'assets/utils/dom/Commands';

export default function ClaimJobPaymentEmailTemplateTags() {
  const { lang } = getLocales();
  const uiEditor = useUIEditor();
  return (
    <DropdownButton
      buttonMedia={<Icon class="fas-plus" />}
      buttonBody={lang.addPlaceholder}
      horizontalPosition="auto_fixed"
      verticalPosition="auto_fixed"
      tabIndex={null}
      htmlElementProps={{
        title: lang.addEmailTemplatePlaceholder,
      }}
      subcomponents={ThemeDropdownButtonPopup}
      dropdownOptions={
        <DataMap
          data={[
            { id: '{{IEmailTemplate_SenderName}}', title: lang.senderName },
            { id: '{{IEmailTemplate_SenderEmail}}', title: lang.senderEmail },
            { id: '{{IPayee_Name}}', title: lang.payeeName },
            { id: '{{IPayee_Address}}', title: lang.payeeAddress },
            { id: '{{IPayee_Email}}', title: lang.payeeEmail },
            { id: '{{ClaimJobPayment_AmountPaid}}', title: lang.paidAmount },
            { id: '{{ClaimJobPayment_PaymentMethodCode}}', title: lang.paymentMethod },
            { id: '{{ClaimJobPaymentDetail_PaymentDate}}', title: lang.paymentDate },
            { id: '{{ClaimJobPaymentDetail_ClaimJobNumbers}}', title: `${lang.claimJob} ${lang.number}s` },
            {
              id: '{{ClaimJobPaymentDetail_ClaimJobAuthorizationNumbers}}',
              title: `${lang.claimJob} ${lang.authorizationNumber}s`,
            },
            {
              id: '{{ClaimJobPaymentDetail_ClaimInvoiceNumbers}}',
              title: `${lang.invoice} ${lang.number}s`,
            },
            { id: '{{Vehicle_Vin}}', title: lang.vin },
            { id: '{{Client_Name}}', title: lang.clientName },
            { id: '{{Contract_AppNumberWithRevision}}', title: `${lang.contract} ${lang.appNumber}` },
            { id: '{{Claim_WorkOrderNumber}}', title: lang.workOrderNumber },
            { id: '{{Claim_Number}}', title: `${lang.claimNumber}` },
          ]}
          render={({ data }) => (
            <Button
              key={data.id}
              class={ThemeButtonMenuItem}
              render={data.title}
              onClick={(data) => uiEditor.applyUiCommand(UICommand.insertHTML, data)}
              data={data.id}
            />
          )}
        />
      }
    />
  );
}
